module.exports = __webpack_public_path__ + "img/black-leopards.f38ef545.png";